import React, { useEffect } from "react";
import { CirclesWithBar } from "react-loader-spinner";

function MainLoader() {
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto"; 
    };
  }, []);

  return (
    <div className="MainLoaderWrapper">
      <div className="MainLoaderWrapperInner">
        <CirclesWithBar
          height="100"
          width="100"
          color="#0f2856"
          outerCircleColor="#0f2856"
          innerCircleColor="#0f2856"
          barColor="#0f2856"
          ariaLabel="circles-with-bar-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    </div>
  );
}

export default MainLoader;
